import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageIcon } from "@/components/PageIcon";
import { SpaSummary } from "@/components/spa/SpaSummary";
import { SpaUnitsTab } from "@/components/spa/SpaUnitsTab";
import { SpaOrdersTab } from "@/components/spa/SpaOrdersTab";
import { SpaReviewTab } from "@/components/spa/SpaReviewTab";
import { SpaLegacyTab } from "@/components/spa/SpaLegacyTab";

const TABS = [["units", "Units"], ["orders", "Draft supplier orders"], ["review", "Needs review"], ["legacy", "Old stock reconciliation"]];

export default function SpaUnitsPage() {
  const [tab, setTab] = useState("units");
  const [summary, setSummary] = useState(null);
  const [filter, setFilter] = useState({});
  const loadSummary = useCallback(() => api.get("/spa-units/summary").then((r) => setSummary(r.data)).catch(() => setSummary(false)), []);
  useEffect(() => { loadSummary(); }, [loadSummary]);
  const pick = (f) => { if (f === "legacy") { setTab("legacy"); return; } setFilter(f); setTab("units"); };
  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-3 lg:pt-4 pb-8" data-testid="spa-units-page">
      <div className="flex items-center gap-3 mb-4"><PageIcon />
        <div><h1 className="text-2xl font-bold text-slate-900">Hot Tub, Swim Spa, Sauna, Pergola &amp; Covana Units</h1>
          <p className="text-sm text-slate-500">Every unit listed individually: where it is, when it arrives and what it is linked to.</p></div>
      </div>
      {summary && <SpaSummary s={summary} onPick={pick} />}
      <div className="flex gap-1 overflow-x-auto border-b border-slate-200 mt-5 mb-4" role="tablist">
        {TABS.map(([k, l]) => (
          <button key={k} role="tab" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={`spa-tab-${k}`}
            className={`whitespace-nowrap px-3 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${tab === k ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>{l}</button>))}
      </div>
      {tab === "units" && <SpaUnitsTab filter={filter} setFilter={setFilter} onChanged={loadSummary} />}
      {tab === "orders" && <SpaOrdersTab />}
      {tab === "review" && <SpaReviewTab />}
      {tab === "legacy" && <SpaLegacyTab />}
    </div>
  );
}
